export const environment = {
  production: false,

  api: {
    protocol: 'https',
    host: 'www.b2blms.com',
    ports: {
      setup: 443,
      facility: 443,
    },
  },

  apiHosts: {
    // mapped via proxy.conf.json to https://www.b2blms.com/api/...
    setup: '/api/setup',
    facility: '/api/facilities',
    client: '/api/clients',
    onboarding: '/api/onboarding',
    cradit: '/api/crdt-prpsl',
    // Monitoring lives in crdt-prpsl-servc (8989) but under its own /mntrng root.
    monitoring: '/api/mntrng',
    repayment: '/api/rpymnt-plan',
    disbursement_note: '/api/dsbmnt-note',
    notification: '/api/ntfctn',
    disbursement: '/api/disbursement',
    payment_recovery: '/api/payment/recovery',
    payment_accrued: '/api/payment/accrued-markup',
    leads: '/api/leads',
    admin: '/api/admin',
    journal: '/api/jrnl',
    brm: '/api/brm',
    recovery: '/api/recovery',
    reports: '/api/reports',
    // The consolidated QPR report sits on the reports service's own
    // /qpr-reports root, alongside /reports rather than inside it.
    qpr_reports: '/api/qpr-reports',
    tasks: '/api/tsk',
    // process-task crdt-prpsl-servc (8989) par /credit root ke neeche hai.
    credit_tasks: '/api/credit/tsk',
  },
};
